export default __webpack_public_path__ + "static/media/youtube.98bb63cc.svg";